import React, { useEffect, useState } from "react";
import { Layout } from "antd";
// import "antd/dist/antd.css";
//import "../style.css/table.css"
// import "../style.css/DSRstyle.css"
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MDBDataTable } from 'mdbreact';
import { ToastContainer, toast } from 'react-toastify';
import { logOut } from "../store/actions/CommonAction";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import loader from "../assets/loader.gif";
import {
  getVerfiybyConsentId,
} from "../store/actions/CommonAction";
import axios from 'axios'; // assuming you're using axios for API calls
//import { TimeoutLogic } from "../utils/TimeoutLogic";


import {
  getDashboard,
  getDashboardDSR,
  getConsentdetailsByTemplateId,
  getEntityList,
  getPurpose,
  getDatatype,
  getConsentDataFromJsonList,
} from "../store/actions/CommonAction";

const { Content } = Layout;

const HomeDSR = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showCVCModal, setShowCVCModal] = useState(false);
  const [shouldRenderGrid, setShouldRenderGrid] = useState(false);
  const [itemVal, setItem] = useState();
  const [isAdvance, setIsAdvance] = useState(false);
  const [gridData, setGridData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dashboarddataDSR = useSelector((state) => state.common.dashboarddataDSR);
  console.log("Dashboard Data of DSR-->" + JSON.stringify(dashboarddataDSR));
  const getTemplateDetail = useSelector(
    (state) => state.common.getTemplateDetail
  );
  const clientId = useSelector((state) => state.common.clientId);
  const clientIdForDashboard = useSelector(
    (state) => state.common.clientIdForDashboard
  );
  const consentDetailList = useSelector(
    (state) => state.common.getConsentDetail
  );
  const templateName = useSelector((state) => state.common.templateName);
  const sessionId = useSelector((state) => state.common.sessionId);
  const consentDataArrayValue = useSelector(
    (state) => state.common.consentDataArrayValue
  );
  const [isLoadingMain, setIsLoadingMain] = useState(true);
  const getProductTheme = useSelector((state) => state.common.getProductTheme);

  const columnsData = [
    {
      headerName: "Sr. No.",
      field: "srno",
      width: 70,
    },
    {
      headerName: "Customer Id ",
      field: "customerId",
      width: 130,
    },
    {
      headerName: "Consent Id",
      field: "consentId",
      width: 130,
    },
    {
      headerName: "Data Shared With",
      field: "dataSharedWith",
      width: 130,
    },
    {
      headerName: "Purpose",
      field: "purpose",
      width: 130,
    },
    {
      headerName: "Created On",
      field: "createdOn",
      width: 130,
      type: "date",
      valueFormatter: (params) => {
        return `${new Date(params.value)}`;
      },
    },
    {
      headerName: "Modified On",
      field: "modifiedOn",
      width: 130,
      type: "date",
      valueFormatter: (params) => {
        return `${new Date(params.value)}`;
      },
    },
    {
      headerName: "Expiry",
      field: "expiry",
      width: 130,
      type: "date",
      valueFormatter: (params) => {
        return `${new Date(params.value)}`;
      },
    },
    {
      headerName: "Verify",
      field: "Verify",
      width: 80,
      type: "text",
      renderCell: (params) => (
        <button
          onClick={() => verifycvc(params.row.consentId)}
          className="btn btn-info m-0"
          style={{ backgroundColor: "#660209", fontSize: "10px" }}
        >
          Verify
        </button>
      ),
    },

    {
      headerName: "Status",
      field: "status",
      width: 130,
      type: "text",
      // cellClassName: (params) =>
      // clsx('super-app', {
      //   positive: params.value == "ACTIVE",
      //   negative: params.value == "INACTIVE"
      // }),
    },
  ];

  const handleClose = async () => {
    setIsLoading(true);
    setGridData("");
    setShow(!show);
    // callAPI()
    await dispatch(getDashboard());
    await dispatch(getEntityList());
    await dispatch(getPurpose());
    await dispatch(getDatatype());
  };

  const callAPI = async () => {
    setIsLoadingMain(true);
    try {
      await dispatch(getDashboardDSR());

    } catch (error) {
      console.error(error);
    }
    setIsLoadingMain(false);
  };

  // const applyTheme = () => {
  //   const menuBar = document.getElementById("menuBar");
  //   if (menuBar) {
  //     menuBar.style.setProperty(
  //       "background-color",
  //       getProductTheme.theme,
  //       "important"
  //     );
  //   }

  //   const consentCards = document.getElementsByClassName("consent-card");
  //   for (let i = 0; i < consentCards.length; i++) {
  //     if (consentCards[i]) {
  //       consentCards[i].style.setProperty(
  //         "border-top",
  //         `4px solid ${getProductTheme.theme}`,
  //         "important"
  //       );
  //     }
  //   }

  //   const cardHeaders = document.getElementsByClassName("card-header");
  //   for (let i = 0; i < cardHeaders.length; i++) {
  //     if (cardHeaders[i]) {
  //       cardHeaders[i].style.setProperty(
  //         "color",
  //         getProductTheme.theme,
  //         "important"
  //       );
  //     }
  //   }

  //   const dashboardHeader = document.getElementById("dashboardHeader");
  //   if (dashboardHeader) {
  //     dashboardHeader.style.setProperty(
  //       "color",
  //       getProductTheme.theme,
  //       "important"
  //     );
  //   }

  //   const dashboardCards = document.getElementsByClassName("dashboard-card");
  //   for (let i = 0; i < dashboardCards.length; i++) {
  //     if (dashboardCards[i]) {
  //       dashboardCards[i].style.setProperty(
  //         "border-top",
  //         `4px solid ${getProductTheme.theme}`,
  //         "important"
  //       );
  //     }
  //   }

  //   const thElements = document.getElementsByTagName("th");
  //   for (let i = 0; i < thElements.length; i++) {
  //     if (thElements[i]) {
  //       thElements[i].style.setProperty(
  //         "color",
  //         getProductTheme.theme,
  //         "important"
  //       );
  //     }
  //   }
  // };

  const signOut = async () => {
    await dispatch(logOut());
    // await dispatch(hideNavbar(false))
    //localStorage.clear();
    history.push("/");
    window.location.reload();
  };
  // eslint-disable-next-line
  useEffect(() => {
    //console.log("Inside if only, Not in else Part" + " " +sessionId )
    if (!sessionId) {
      console.log("Inside if only not in else" + " " + sessionId);
      signOut();
    } else {
      console.log("Sucess..............." + " " + sessionId);
      callAPI();
      // alert("getProductTheme.theme : "+getProductTheme.theme);
      //applyTheme();

      if (show) {
        const timer = setTimeout(() => {
          setShouldRenderGrid(true);
        }, 100); // Adjust the delay value as needed
        // Clear the timer on unmount / effect re-run
        return () => clearTimeout(timer);
      } else {
        setShouldRenderGrid(false);
      }
    }
  }, [show, sessionId]);

  useEffect(() => {
    const handleUnload = () => {
      // Perform actions before the component unloads
      //dispatch(clearSession());
    };
    window.addEventListener("unload", handleUnload);
    return () => {
      window.removeEventListener("unload", handleUnload);
    };
  }, [dispatch]);

  const verifycvc = async (consentId) => {
    try {
      await dispatch(getVerfiybyConsentId(consentId));

      setShowCVCModal(!showCVCModal);
    } catch (error) {
      console.error(error);
    }
  };

  // Updated columns
  const columns = [
    {
      label: <>
        Request ID
        <i className="fa fa-sort float-right" aria-hidden="true"></i>
      </>,
      field: 'requestID',
      sort: 'asc',
      width: 150
    },
    {
      label: <>
        Creation Date
        <i className="fa fa-sort float-right" aria-hidden="true"></i>
      </>,
      field: 'creationdate',
      sort: 'asc',
      width: 270
    },
    // {
    //   label: <>
    //     Status
    //     <i className="fa fa-sort float-right" aria-hidden="true"></i>
    //   </>,
    //   field: 'status',
    //   sort: 'asc',
    //   width: 200
    // },
    {
      label: <>
      Status
      </>,
      field: 'updateAction',
      width: 100
    },
    {
      label: <>
        Data Principle
        <i className="fa fa-sort float-right" aria-hidden="true"></i>
      </>,
      field: 'dataPrincipal',
      sort: 'asc',
      width: 100
    },
    {
      label: <>
        Request Type
        <i className="fa fa-sort float-right" aria-hidden="true"></i>
      </>,
      field: 'drpAction',
      sort: 'asc',
      width: 150
    },
    {
      label: <>
        Status Update
        <i className="fa fa-sort float-right" aria-hidden="true"></i>
      </>,
      field: 'updatedAt',
      sort: 'asc',
      width: 100
    }
  ];


  const updateStatus = (requestID, newStatus, dataPrincipal) => {
    //alert("Inside updateStatus Function")
    // API call to update status
    axios.put(`http://10.162.6.84:9019/dsr/v1.0/updateDSRStatus/${requestID}`, 
    { currentStatus: newStatus,updateBy: dataPrincipal })
      .then((response) => {
        console.log(response);
        if (response && response.data) {
          toast.info(response.data.status);
        } else {
          toast.error('Error updating status');
        }
      })
      .catch((error) => {
        //alert(JSON.stringify(error));
        toast.error('Error updating status:', error);
      });
};

const handleUpdateActionChange = (event, rowData) => {
  // Access the requestID, selected updateAction, and dataPrincipal from the rowData object
  const requestID = rowData.dsrPrivacyId;
  const selectedUpdateAction = event.target.value;
  const dataPrincipal = rowData.dataPrincipal;

  console.log('Selected Request ID:', requestID);
  console.log('Selected Update Action:', selectedUpdateAction);
  console.log('Data Principal:', dataPrincipal);

  updateStatus(requestID, selectedUpdateAction, dataPrincipal)
};

  // const rows = dashboarddataDSR && dashboarddataDSR.dsrList ? dashboarddataDSR.dsrList.map((item) => {
  //   const createDate = new Date(item.createdAt).toLocaleDateString('en-GB');
  //   const updateDate = new Date(item.updatedAt).toLocaleDateString('en-GB');
  //   return {
  //     requestID: item.dsrPrivacyId,
  //     creationdate: createDate,
  //     status: item.currentStatus,
  //     dataPrincipal: item.dataPrincipal,
  //     drpAction: item.drpAction,
  //     updatedAt: updateDate,
  //     updateAction: (
  //       <select>
  //         <option value="SUBMITTED">SUBMITTED</option>
  //         <option value="ACKNOWLEDGED">ACKNOWLEDGED </option>
  //         <option value="PROCESSED">PROCESSED </option>
  //         <option value="REPORTSENT">REPORTSENT </option>
  //         <option value="REJECTED">REJECTED </option>
  //       </select>
  //     )
  //   };
  // }) : [];

  const rows = dashboarddataDSR && dashboarddataDSR.dsrList ? dashboarddataDSR.dsrList.map((item) => {
    const createDate = new Date(item.createdAt).toLocaleDateString('en-GB');
    const updateDate = new Date(item.updatedAt).toLocaleDateString('en-GB');
    return {
      requestID: item.dsrPrivacyId,
      creationdate: createDate,
      //status: item.currentStatus,
      dataPrincipal: item.dataPrincipal,
      drpAction: item.drpAction,
      updatedAt: updateDate,
      updateAction: (
        <select onChange={(event) => handleUpdateActionChange(event, item)} value={item.currentStatus} disabled={item.currentStatus === 'REJECTED'}>
          <option value="SUBMITTED">SUBMITTED</option>
          <option value="ACKNOWLEDGED">ACKNOWLEDGED</option>
          <option value="PROCESSED">PROCESSED</option>
          <option value="REPORTSENT">REPORTSENT</option>
          <option value="REJECTED">REJECTED</option>
        </select>
      )
    };
  }) : [];


  // Updated data object
  const data = {
    columns: columns,
    rows: rows
  };


  return (
    <>
      {isLoadingMain ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <Content style={{ padding: 30 }}>
          {/* <div className="pt-2 pb-2">
          <h5 onClick={callRefresh} className="font-weight-bold">Dashboard</h5>
      </div> */}
          {show && dashboarddataDSR.templateDetails && (
            <div class="modalLikeBox">
              <div class="modalLikeHead">
                <div class="modalLikeTitle">
                  <span style={{ textTransform: "initialcase" }}>
                    {templateName}
                  </span>
                </div>
              </div>

              <div class="modalLikeBody">
                {shouldRenderGrid &&
                  consentDetailList &&
                  consentDetailList.length > 0 && (
                    <Box
                      sx={{
                        width: "100%",
                        "& .super-app-theme--cell": {
                          backgroundColor: "rgba(224, 183, 60, 0.55)",
                          color: "#fff",
                        },
                        "& .super-app.negative": {
                          backgroundColor: "#f5222d",
                          color: "#fff",
                        },
                        "& .super-app.positive": {
                          backgroundColor: "#28a745",
                          color: "#fff",
                        },
                      }}
                    >
                      <div style={{ height: 400, width: "100%" }}>
                        {isLoading ? (
                          <div class="text-center">
                            <img
                              src={loader}
                              style={{ height: "100px", textAlign: "center" }}
                            ></img>
                            <br></br>
                            <b>Loading...</b>
                          </div>
                        ) : (
                          <DataGrid
                            rows={gridData}
                            columns={columnsData}
                            getRowId={(row) => row.srNo + row.consentId}
                            initialState={{
                              pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                              },
                            }}
                            pageSizeOptions={[5, 10]}
                            components={{
                              Toolbar: GridToolbar,
                            }}
                            slots={{ toolbar: GridToolbar }}
                            className="table dashboard-table dashboard-card"
                          />
                        )}
                      </div>
                    </Box>
                  )}
                {consentDetailList && consentDetailList.length == 0 && (
                  <h6 style={{ color: "#777777" }}>No Consents Available</h6>
                )}
              </div>
              <div class="modalLikeFooter">
                {/* <MaterialButton variant="contained" color="primary"  onClick={handleClose}>Close</MaterialButton> */}
                <button
                  type="button"
                  onClick={handleClose}
                  className="btn btn-outline-secondary btn-sm "
                >
                  Close
                </button>
              </div>
            </div>
          )}

          {dashboarddataDSR && (
            <div className="row" style={{ marginTop: "5%" }}>
              <div className="col-sm-12">
                <div className="card consent-card">
                  <h5 className="card-header fw-bold">Request Status</h5>
                  <div className="card-body  p-0">
                    <div className="d-flex flex-row justify-content-around flex-grow-1">
                      {dashboarddataDSR.stat && (
                        <>
                          <div className="p-3 text-center">
                            <h6 className="fw-bold text-success mb-3">DSR Submitted</h6>
                            <h5 className="text-success h3">{dashboarddataDSR.stat.dsrSubmitted}</h5>
                          </div>
                          <div className="p-3 text-center">
                            <h6 className="fw-bold text-danger mb-3">DSR Acknowledged</h6>
                            <h5 className="text-danger h3">{dashboarddataDSR.stat.dsrAcknowleged}</h5>
                          </div>
                          <div className="p-3 text-center">
                            <h6 className="fw-bold text-warning mb-3">DSR Processed</h6>
                            <h5 className="text-warning h3">{dashboarddataDSR.stat.dsrProcessed}</h5>
                          </div>
                          <div className="p-3 text-center">
                            <h6 className="fw-bold text-info mb-3">DSR Completed</h6>
                            <h5 className="text-info h3">{dashboarddataDSR.stat.dsrCompleted}</h5>
                          </div>
                          <div className="p-3 text-center">
                            <h6 className="fw-bold text-info mb-3">DSR Rejected</h6>
                            <h5 className="text-info h3">{dashboarddataDSR.stat.dsrRejected}</h5>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}


          <div className="pt-2 pb-2 mt-3 mb-2 dashboard-headers">
            <h5 className="font-weight-bold" id="dashboardHeader">
              View Requests
            </h5>
          </div>

          <MDBDataTable
            responsive
            hover
            striped
            bordered
            //small
            data={data}
            sortable={true}
            noBottomColumns
            noBottomColumnsBorders
          />

          {/* <TimeoutLogic /> */}
          <ToastContainer></ToastContainer>
        </Content>
      )}

    </>
  );
};

export default HomeDSR;
